(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statistics-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    const section = document.querySelector('.statistics-grid-section');
    if (!section) return;

    const statItems = section.querySelectorAll('.stat-item');
    if (!statItems.length) return;


    function formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }


    function animateNumber(element, target, duration = 2000) {
      const numberDisplay = element.querySelector('.stat-number');
      if (!numberDisplay) return;

      const start = 0;
      const startTime = performance.now();

      if (target === 0) {
        numberDisplay.textContent = '0';
        return;
      }

      function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3); 
        const current = Math.floor(eased * target);

        numberDisplay.textContent = formatNumber(current);

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {

          numberDisplay.textContent = formatNumber(target);
        }
      }

      requestAnimationFrame(update);
    }


    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const item = entry.target;
          if (item.dataset.animated === 'true') return;

          const targetNumber = parseInt(item.dataset.number, 10);
          if (isNaN(targetNumber)) return;

          item.dataset.animated = 'true';
          animateNumber(item, targetNumber);
          observer.unobserve(item);
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
    });

    statItems.forEach(item => observer.observe(item));


    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const threshold = 0.3;
      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
      return visibleHeight >= rect.height * threshold;
    }

    window.addEventListener('load', function() {
      statItems.forEach((item) => {
        if (isElementInViewport(item) && item.dataset.animated !== 'true') {
          const targetNumber = parseInt(item.dataset.number, 10);
          if (!isNaN(targetNumber)) {
            item.dataset.animated = 'true';
            animateNumber(item, targetNumber);
            observer.unobserve(item);
          }
        }
      });
    });


    let scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) return;
      scrollTimeout = setTimeout(() => {
        statItems.forEach((item) => {
          if (isElementInViewport(item) && item.dataset.animated !== 'true') {
            const targetNumber = parseInt(item.dataset.number, 10);
            if (!isNaN(targetNumber)) {
              item.dataset.animated = 'true';
              animateNumber(item, targetNumber);
              observer.unobserve(item);
            }
          }
        });
        scrollTimeout = null;
      }, 100);
    }, { passive: true });

  })();

  } catch(e) { console.error(e); }
})();
})();
